export const OLD_UNIT_VIEW = "old";
export const NEW_UNIT_VIEW = "new";
